/* TALU Magnetic Buttons - 2026-05-19
   Efecto de "boton magnetico": el boton sigue suavemente al cursor
   con un offset proporcional + scale sutil. Desktop (mouse) y mobile (touch).
   Aplicable a: .btn-now, .btn-buy-now en cta-stack.
*/
(function () {
  'use strict';

  var SELECTOR = '.btn-now, .btn-buy-now';
  var STRENGTH_X = 0.18;
  var STRENGTH_Y = 0.28;
  var TOUCH_X = 0.12;
  var TOUCH_Y = 0.20;
  var SCALE_HOVER = 1.04;
  var SCALE_TOUCH = 1.03;

  function reset(btn) {
    btn.style.transform = '';
  }

  function applyMove(btn, clientX, clientY, sx, sy, scl) {
    var rect = btn.getBoundingClientRect();
    var dx = clientX - rect.left - rect.width / 2;
    var dy = clientY - rect.top - rect.height / 2;
    var tx = dx * sx;
    var ty = dy * sy;
    btn.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0) scale(' + scl + ')';
  }

  function bind(btn) {
    if (btn.__taluMagnetic) return;
    btn.__taluMagnetic = true;

    // Forzar transition suave (sobre-escribe el !important de overrides via inline style)
    btn.style.transitionProperty = 'transform, box-shadow, background';
    btn.style.transitionDuration = '420ms';
    btn.style.transitionTimingFunction = 'cubic-bezier(.16,.85,.28,1)';
    btn.style.willChange = 'transform';

    btn.addEventListener('mousemove', function (e) {
      applyMove(btn, e.clientX, e.clientY, STRENGTH_X, STRENGTH_Y, SCALE_HOVER);
    });
    btn.addEventListener('mouseleave', function () {
      reset(btn);
    });
    btn.addEventListener('mousedown', function () {
      btn.style.transitionDuration = '180ms';
    });
    btn.addEventListener('mouseup', function () {
      btn.style.transitionDuration = '420ms';
    });

    // Touch (mobile)
    btn.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      var t = e.touches[0];
      applyMove(btn, t.clientX, t.clientY, TOUCH_X, TOUCH_Y, SCALE_TOUCH);
    }, { passive: true });
    btn.addEventListener('touchmove', function (e) {
      if (!e.touches[0]) return;
      var t = e.touches[0];
      applyMove(btn, t.clientX, t.clientY, TOUCH_X, TOUCH_Y, SCALE_TOUCH);
    }, { passive: true });
    btn.addEventListener('touchend', function () {
      reset(btn);
    });
    btn.addEventListener('touchcancel', function () {
      reset(btn);
    });
  }

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return; // accesibilidad
    }
    scan();
    var obs = new MutationObserver(function () {
      scan();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
